export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 100,
    slots: { default: 'opt' },
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_evgPackingSchemeNo') || '方案编号',
    field: 'evgPackingSchemeNo',
    minWidth: 140,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_evgPackingSchemeStatus') || '状态',
    field: 'evgPackingSchemeStatus',
    minWidth: 100,
    align: 'center',
    slots: { default: 'status' },
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_evgPackingSchemeName') || '方案名称',
    field: 'evgPackingSchemeName',
    minWidth: 220,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_platformName') || '出货渠道',
    field: 'platformName',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_custName') || '客户',
    field: 'custName',
    minWidth: 240,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_bookingType') || '订舱类型',
    field: 'v_bookingType',
    minWidth: 80,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_containerName') || '出运箱型',
    field: 'containerName',
    minWidth: 80,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_inContainerQty') || '装柜入数',
    field: 'inContainerQty',
    minWidth: 80,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_totCntInContainerQty') || '入柜总箱数',
    field: 'totCntInContainerQty',
    minWidth: 100,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_totUnitInContainerQty') || '入柜总产品数',
    field: 'totUnitInContainerQty',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_totSpecInContainerQty') || '入柜总规格数',
    field: 'totSpecInContainerQty',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_salesPersonName') || '业务',
    field: 'salesPersonName',
    minWidth: 160,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_merchandiserCode') || '跟单',
    field: 'merchandiserName',
    minWidth: 160,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_ftyPersonCode') || '工厂跟单',
    field: 'ftyPersonName',
    minWidth: 160,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_regionName') || '运抵国',
    field: 'regionName',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_dispatchPort') || '出运港口',
    field: 'v_dispatchPort',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_createdBy') || '创建人',
    field: 'createByName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 170,
    showHeaderOverflow: true,
    slots: { default: 'createByName' },
  },
  {
    title: that.$l('table_label_modifiedBy') || '修改人',
    field: 'modifyByName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 170,
    slots: { default: 'modifyByName' },
    showHeaderOverflow: true,
  },
]
